module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/banner_maripic@3x-b8e4f7cc52211b31f16ad7bdb6148da6.webp";